import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_SecretForm = _resolveComponent("SecretForm")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_breadcrumb, {
      size: "is-large",
      separator: "has-succeeds-separator",
      "aria-label": "breadcrumbs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_breadcrumb_item, {
          tag: "a",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({name: 'secret-list'})), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('secrets.title')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_b_breadcrumb_item, { active: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('secrets.addNew')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SecretForm, {
        ref: "secretForm",
        onSaved: _ctx.onSaved,
        onValid: _cache[1] || (_cache[1] = v => (_ctx.canSave = v))
      }, null, 8, ["onSaved"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_b_button, {
          type: "is-primary",
          disabled: !_ctx.canSave,
          onClick: _ctx.triggerSave
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('global.save')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_b_button, {
          class: "ml-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.back()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('global.back')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}